/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    V1ResourceClaim,
    V1ResourceClaimFromJSON,
    V1ResourceClaimFromJSONTyped,
    V1ResourceClaimToJSON,
} from './V1ResourceClaim';

/**
 * 
 * @export
 * @interface V1ResourceRequirements
 */
export interface V1ResourceRequirements {
    /**
     * Claims lists the names of resources, defined in spec.resourceClaims,
     * that are used by this container.
     * 
     * This is an alpha field and requires enabling the
     * DynamicResourceAllocation feature gate.
     * 
     * This field is immutable. It can only be set for containers.
     * 
     * +listType=map
     * +listMapKey=name
     * +featureGate=DynamicResourceAllocation
     * +optional
     * @type {Array<V1ResourceClaim>}
     * @memberof V1ResourceRequirements
     */
    claims?: Array<V1ResourceClaim>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof V1ResourceRequirements
     */
    limits?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof V1ResourceRequirements
     */
    requests?: { [key: string]: string; };
}

export function V1ResourceRequirementsFromJSON(json: any): V1ResourceRequirements {
    return V1ResourceRequirementsFromJSONTyped(json, false);
}

export function V1ResourceRequirementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1ResourceRequirements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'claims': !exists(json, 'claims') ? undefined : ((json['claims'] as Array<any>).map(V1ResourceClaimFromJSON)),
        'limits': !exists(json, 'limits') ? undefined : json['limits'],
        'requests': !exists(json, 'requests') ? undefined : json['requests'],
    };
}

export function V1ResourceRequirementsToJSON(value?: V1ResourceRequirements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'claims': value.claims === undefined ? undefined : ((value.claims as Array<any>).map(V1ResourceClaimToJSON)),
        'limits': value.limits,
        'requests': value.requests,
    };
}

